<app-selector [label]="name" [isEmptySelectable]="isEmptySelectable" [data]="miniGameCoreService.miniGameList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="miniGameCoreService.loading" [hint]="hint">
</app-selector>